import { IconBack } from './icons/IconBack';

export const Icons = {
  IconBack,
};
